import {ZahavDayType} from '@sollapay/enums';
import {addDaysToIsoDate, getIsoWeekday} from '@sollapay/utils';

const FRIDAY = 5;
const SATURDAY = 6;

/**
 * Bank of Israel Zahav calendar exceptions (holidays, eves, elections) — update by hand from
 * https://boi.org.il/en/economic-roles/payment-systems/payment-systems-in-israel/zahav/ whenever BoI
 * publishes a new year or revises one. Days absent here follow the weekly pattern: Sun–Thu
 * regular, Fri short, Sat closed.
 */
export const ZAHAV_CALENDAR: Readonly<Record<string, ZahavDayType>> = {
  '2026-10-27': ZahavDayType.CLOSED,
  '2027-03-23': ZahavDayType.CLOSED,
  '2027-04-21': ZahavDayType.SHORT,
  '2027-04-22': ZahavDayType.CLOSED,
  '2027-04-27': ZahavDayType.SHORT,
  '2027-04-28': ZahavDayType.CLOSED,
  '2027-05-11': ZahavDayType.SHORT,
  '2027-05-12': ZahavDayType.CLOSED,
  '2027-06-10': ZahavDayType.SHORT,
  '2027-06-11': ZahavDayType.CLOSED,
  '2027-08-12': ZahavDayType.CLOSED,
  '2027-10-01': ZahavDayType.SHORT,
  '2027-10-02': ZahavDayType.CLOSED,
  '2027-10-03': ZahavDayType.CLOSED,
  '2027-10-10': ZahavDayType.CLOSED,
  '2027-10-11': ZahavDayType.CLOSED,
  '2027-10-15': ZahavDayType.SHORT,
  '2027-10-16': ZahavDayType.CLOSED,
  '2027-10-22': ZahavDayType.SHORT,
  '2027-10-23': ZahavDayType.CLOSED
};

/** How the bank operates on a `YYYY-MM-DD` date: a calendar exception, else the weekly pattern. */
export function getBankDayType(
  isoDate: string,
  weekday: number = getIsoWeekday(isoDate)
): ZahavDayType {
  const exception = ZAHAV_CALENDAR[isoDate];
  if (exception) return exception;
  if (weekday === SATURDAY) return ZahavDayType.CLOSED;
  return weekday === FRIDAY ? ZahavDayType.SHORT : ZahavDayType.REGULAR;
}

/** Money settles Sun–Thu only, never on bank holidays — Friday is open for Zahav but doesn't settle. */
export function isBankSettlementDay(isoDate: string): boolean {
  const weekday = getIsoWeekday(isoDate);
  return weekday !== FRIDAY && getBankDayType(isoDate, weekday) !== ZahavDayType.CLOSED;
}

export function addBankSettlementDays(isoDate: string, days: number): string {
  let result = isoDate;
  let remaining = days;
  while (remaining > 0) {
    result = addDaysToIsoDate(result, 1);
    if (isBankSettlementDay(result)) remaining -= 1;
  }
  return result;
}
